import { render, staticRenderFns } from "./chatBroadcastDialog.vue?vue&type=template&id=5bad17a2&scoped=true"
import script from "./chatBroadcastDialog.vue?vue&type=script&lang=js"
export * from "./chatBroadcastDialog.vue?vue&type=script&lang=js"
import style0 from "./chatBroadcastDialog.vue?vue&type=style&index=0&id=5bad17a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad17a2",
  null
  
)

export default component.exports